import { Responsive, WidthProvider } from 'react-grid-layout';
import 'react-grid-layout/css/styles.css';
import React from 'react';
import { Box } from '@chakra-ui/react';
import { Icons } from '@texas/components/shared/Icons';

const ResponsiveGridLayout = WidthProvider(Responsive);

export interface GridLayoutProps {
  isDraggable?: boolean;
  isResizable?: boolean;
}

export function WidgetsLayout({
  children,
  layout,
  onLayoutChange,
  gridProps,
}: {
  children: React.ReactNode;
  layout: ReactGridLayout.Layouts;
  onLayoutChange: (
    currentLayout: ReactGridLayout.Layout[],
    allLayouts: ReactGridLayout.Layouts,
  ) => void;
  gridProps?: GridLayoutProps;
}) {
  return (
    <Box pb={12}>
      <ResponsiveGridLayout
        {...gridProps}
        onLayoutChange={onLayoutChange}
        draggableHandle=".header"
        draggableCancel=".ignore"
        className=""
        layouts={layout}
        rowHeight={85}
        breakpoints={{ lg: 1620, md: 1320 }}
        cols={{ lg: 12, md: 12 }}
        resizeHandle={gridProps?.isResizable ? <CustomHandle /> : null}
      >
        {children}
      </ResponsiveGridLayout>
    </Box>
  );
}

const CustomHandle = React.forwardRef<SVGSVGElement, any>(function CustomHandle(
  props,
  ref,
) {
  const { handleAxis, ...restProps } = props;
  return (
    <Icons.ResizeBottomRight
      pos="absolute"
      right={2}
      bottom={2}
      cursor="se-resize"
      className={`handle-${handleAxis}`}
      {...restProps}
      ref={ref}
    />
  );
});
